export default __webpack_public_path__ + "static/media/ead16c555f3726ee6b5d9474fdbf8081.svg";